var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g({staticClass:"b-icon"},_vm.$listeners),[_c(_vm.name,{tag:"component",staticClass:"b-icon__icon",style:(_vm.styleVal)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }